import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const SecureFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M20.34 5.96a.83.83 0 0 0-.27-.56.823.823 0 0 0-.58-.2c-3.93.26-6.95-2.51-6.98-2.54a.8.8 0 0 0-1.12.03c-2.59 2.72-6.84 2.5-6.88 2.5a.823.823 0 0 0-.58.2c-.16.14-.25.34-.27.55-.33 6.49.37 13.4 8.14 15.46.07.02.14.03.21.03.07 0 .14 0 .21-.03 7.76-2.06 8.47-8.98 8.14-15.46l-.02.02Zm-4.5 4.31-4.5 4.5c-.14.14-.33.22-.52.22s-.38-.07-.52-.22l-2.14-2.14a.742.742 0 1 1 1.05-1.05l1.62 1.61 3.98-3.98a.742.742 0 1 1 1.05 1.05l-.02.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default SecureFilled
